var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['scroll-down-indicator', { hasScrolled: _vm.hasScrolled }]},[_vm._v("Scroll down "),_c('IconArrowLeft')],1)}
var staticRenderFns = []

export { render, staticRenderFns }